namespace TabAurous.Sales {
    export namespace TopProductsService {
        export const baseUrl = 'Sales/TopProducts';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Sales/TopProducts/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>TopProductsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
